<template>
    <DnModal
        v-bind="$attrs"
        class="uro-modal"
        @close="$emit('close')"
    >
        <template #close-button>
            <base-icon
                class="dn-modal__close dn-icon--square"
                icon="close"
                @click="$emit('close')"
            />
        </template>
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
    </DnModal>
</template>


<script setup>
import DnModal from '@digitalnatives/modal';
defineEmits(['close']);
</script>

<style lang="less">
.uro-modal.dn-modal {
    --border-radius: var(--borderRadius-sm);
    --box-shadow: 0 0 5px rgba(0, 0, 0, .25);
    --max-width: 38.75rem;
    --padding: 2rem;

    .dn-modal__close {
        font-size: 1.75rem;
    }

    @media @q-md-min {
        .dn-modal__close {
            top: var(--padding);
            right: var(--padding);
            font-size: 2rem;
        }
    }

}

.uro-modal.dn-modal[data-large='true'] {
    --max-width: 100vw;
}

.dn-modal__main {
    .typography-text;

    /** Compensate for close-button placement */
    padding-right: calc(var(--padding) * 2);
}
</style>
